<div class="col">
  <h3>Limite Pagamento ECG por Terceiros</h3>
</div>
<section class="container">
    <div class="bn-form-group row">
      <div class="d-flex justify-content-end">
        <button
            type="button"
            class="btn btn-primary"
            [routerLink]="['/limite-pagamento-ecg-por-terceiros/cadastro']">
            <i class="fa fa-file-signature"></i>
            Cadastrar/Editar Limite por Modalidade
        </button>
        <button type="button" class="btn btn-primary" [routerLink]="['/limite-pagamento-ecg-por-terceiros/historico']">
            <i class="fa fa-clock"></i>
            Histórico
        </button>
      </div>
    </div>

    <app-limite-pagamento-ecg-por-terceiros-listagem
      [limites]="limites"
      [dataHoraResultado]="dataHoraResultado"
    >
    </app-limite-pagamento-ecg-por-terceiros-listagem>
  </section>
